import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import Paper from "commons/ui/Paper";

import { FormCollectionHookType } from "hooks/form/useCollectionForm";

function CollectionForm({ formCollectionHook }: { formCollectionHook: FormCollectionHookType }) {
    const { formHook } = formCollectionHook;

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                label={"Nome"}
                                value={form.name}
                                setValue={setValue}
                                path={"name"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>
                </GridColumn>
            </Paper>
        </GridColumn>
    );
}

export default CollectionForm;
